// extracted by mini-css-extract-plugin
module.exports = {"title":"AlgoliaPostsMosaic_title__moVoH","filters":"AlgoliaPostsMosaic_filters__fC9gJ"};